import { SurveyConfigModule } from "@max/common/setfan";
import { useSurveyContext } from "Components/SurveyContext";
import DOMPurify from "dompurify";

DOMPurify.setConfig({ ADD_ATTR: ["onclick", "target"] });

DOMPurify.addHook("uponSanitizeAttribute", (_, data) => {
  if (data.attrName === "onclick") {
    data.keepAttr =
      data.attrValue === "(function(e){ e.stopPropagation();})(arguments[0]);";
  }

  if (data.attrName === "target") {
    // double underscore for legacy, single for correct/new
    data.keepAttr = ["_blank", "__blank"].includes(data.attrValue);
  }

  return data;
});

export const HtmlModule = ({
  content,
  className = "",
  style,
  stylesheet,
  // trusted is a flag that we can set on the survey config module in order
  // to skip sanitization of content.
  // NOTE: This is not currently set up to adjust in the editor. You
  // have to make a direct update to the survey config module in firestore
  trusted = false,
}: SurveyConfigModule) => {
  const { rawSurvey } = useSurveyContext();

  const surveyVersion = rawSurvey.version ?? 0;

  let sanitizedContent = "";
  if (!trusted && surveyVersion >= 2) {
    try {
      sanitizedContent = DOMPurify.sanitize(content);
    } catch (err) {
      console.error(err);
    }
  } else {
    sanitizedContent = content;
  }

  return (
    // we take a passed class here in order to scope the stylesheet to this module only
    <>
      {!!stylesheet && <style>{stylesheet}</style>}
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        style={style}
      />
    </>
  );
};
